<template>
  <ManageSuppliers />
</template>
<script>
import appConfig from '@/app.config'

import ManageSuppliers from '@/components/skillup/suppliers/ManageSuppliers.vue'

export default {
  page: {
    title: 'مدیریت تامین کنندگان',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'skillUp-add-suppliers',
  components: {
    ManageSuppliers,
  },
}
</script>
